import Vue from 'vue';
import Vuex from 'vuex';
import Router from '../Router';
import Services from '../Service';
import Config from '../Config';
import {
  CONN
}
from '../Enums';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    Conf: null,
    Logs: {},
    Connection: false,
    ConnectionStatus: CONN.DISCONNECTED,
    User: null,
    AccessToken: null,
    StoreData: null,
    FocusedData: null,
    Loadings: [],
    ErrorStatus: false,
    ErrorText: '',
    WarningStatus: false,
    WarningText: '',
    ToastMessages: [],
    Table: 0,
    Tables: 0,
    Products: 0,
    Data2: 0,
    LoginUsername: '',
    LoginPassword: '',
    AutomaticLogin: 9999,
    OldPassword: '',
    NewPassword: '',
    NewPassOnlyNum: '',
    ScreenWidth: 768,
    ScreenSize: 'md',
    ButtonSize: 'lg',
  },
  getters: {
    GetConnection: (state) => state.Connection,
    GetConnectionStatus: (state) => state.ConnectionStatus,
    IsLoading: (state) => {
      return state.Loadings.length > 0;
    },
    GetStoreData: (state) => state.StoreData,
  },
  mutations: {
    SetConf(state, Conf) {
      state.Conf = Conf;
    },
    SetLog(state, {
      Key,
      Value
    }) {
      state.Logs[Key] = Value;
    },
    ClearLogs(state) {
      state.Logs = {};
    },
    SetConnection(state, WS) {
      state.Connection = WS;
    },
    SetConnectionStatus(state, Status) {
      state.ConnectionStatus = Status;
    },
    SetAccessToken(state, Token) {
      state.AccessToken = Token;
    },
    SetChannelData(state, Data) {
      state[Data.Channel] = Data.Data;
    },
    SetFocusedData(state, Data) {
      state.FocusedData = Data;
    },
    SetUser(state, User) {
      state.User = User;
    },
    SetPasswordLength(state, PasswordLength) {
      state.User.PasswordLength = PasswordLength;
    },
    SetAutomaticLogin(state, AutomaticLogin) {
      state.User.AutomaticLogin = AutomaticLogin;
    },
    SetStoreData(state, StoreData) {
      const Bindings = {
        Places: {},
        Tables: {},
        Products: {},
        Categories: {},
        Staff: {},
        Kitchens: {},
        PaymentTypes: {},
      };

      if (StoreData !== null) {
        if (typeof StoreData.Categories === "object")
          StoreData.Categories.forEach(_Category => {
            _Category.Products = {};
            Bindings.Categories[_Category.ID] = _Category;
          });

        Bindings.PaymentTypes = StoreData.PaymentTypes;
        // if (typeof StoreData.PaymentTypes === "object")
        //   StoreData.PaymentTypes.forEach(_Type => {
        //     Bindings.PaymentTypes[_Type.ID] = _Type;
        //   });

        Bindings.Roles = StoreData.Roles;

        if (typeof StoreData.Kitchens === "object") {
          const _Kitchens = StoreData.Kitchens;
          Bindings.Kitchens = {};

          _Kitchens.forEach(_Kitchen => {
            if (typeof _Kitchen.Products === "object") {
              const _Products = _Kitchen.Products;
              _Kitchen.Products = {};

              _Products.forEach(_Product => {
                if (_Product.ExtraTypes) {
                  const _ExtraTypes = _Product.ExtraTypes;
                  _Product.ExtraTypes = {};

                  _ExtraTypes.forEach(_ExtraType => {
                    if (_ExtraType.Extras) {
                      const _Extras = _ExtraType.Extras;
                      _ExtraType.Extras = {};

                      _Extras.forEach(_Extra => {
                        _ExtraType.Extras[_Extra.ID] = _Extra;
                      });
                    }

                    _Product.ExtraTypes[_ExtraType.ID] = _ExtraType;
                  });
                }

                _Kitchen.Products[_Product.ID] = _Product;
                Bindings.Categories[_Product.CategoryID].Products[_Product.ID] = _Product;
                Bindings.Products[_Product.ID] = _Product;
              });
            }

            Bindings.Kitchens[_Kitchen.ID] = _Kitchen;
          });
        }

        if (typeof StoreData.Staff === "object") {
          StoreData.Staff.forEach(_User => {
            if (_User.Phone === undefined) _User.Phone = '';

            Bindings.Staff[_User.ID] = _User;
          });
        }

        if (typeof StoreData.Places === "object")
          StoreData.Places.forEach(_Place => {
            if (typeof _Place.Tables === "object") {
              const _Tables = _Place.Tables;
              _Place.Tables = {};

              _Tables.forEach(_Table => {
                _Table.PlaceName = _Place.Name;

                if (_Table.Session) {
                  _Table.Session = _Table.Session[0];

                  if (_Table.Session.Orders) {
                    const _Orders = _Table.Session.Orders;
                    _Table.Session.Orders = {};

                    _Orders.forEach(_Order => {
                      if (_Order.Extras) {
                        const _Extras = _Order.Extras;
                        _Order.Extras = {};

                        _Extras.forEach(_Extra => {
                          _Order.Extras[_Extra.ID] = _Extra;
                        });
                      }

                      if (_Order.Processes) {
                        const _Processes = _Order.Processes;
                        _Order.Processes = {};

                        _Processes.forEach(_Process => {
                          _Order.Processes[_Process.ID] = _Process;
                        });
                      }

                      if (_Order.LastProcess) {
                        _Order.LastProcess = _Order.LastProcess[0];
                      }

                      _Table.Session.Orders[_Order.ID] = _Order;
                    });
                  }

                  if (_Table.Session.Payments) {
                    const _Payments = _Table.Session.Payments;
                    _Table.Session.Payments = {};

                    _Payments.forEach(_Payment => {
                      _Table.Session.Payments[_Payment.ID] = _Payment;
                    });
                  }
                }

                Bindings.Tables[_Table.ID] = _Table;
                _Place.Tables[_Table.ID] = _Table;
              });
            }

            Bindings.Places[_Place.ID] = _Place;
          });
      }

      state.StoreData = Bindings;
    },
    SetData(state, Data) {
      state[Data.Key] = Data.Value;
    },
    AddLoading(state, Name) {
      state.Loadings.push(Name);
    },
    RemoveLoading(state, Name) {
      state.Loadings.splice(state.Loadings.indexOf(Name), 1)
    },
    GiveError(state, Text) {
      state.ErrorStatus = true;
      state.ErrorText = Text;
    },
    ShowWarning(state, Text) {
      state.WarningStatus = true;
      state.WarningText = Text;
    },
    RemoveAlerts(state) {
      state.ErrorStatus = false;
      state.WarningStatus = false;
    },
    RemoveSoftAlerts(state) {
      state.WarningStatus = false;
    },
    AddToastMessage(state, Data) {
      state.ToastMessages.push(Data);
    },
    DeleteToastMessage(state, ID) {
      state.ToastMessages.splice(ID, 1);
    },
    ClearToastMessages(state) {
      state.ToastMessages = [];
    },
    UpdateState() {},
    Up(state, Data) {
      Services.Nozich.Up(state, Data);

      if (Data.El[0] === 'AutomaticLogin')
        localStorage.setItem('AutomaticLogin', Data.Value)
    },
    Del(state, Data) {
      Services.Nozich.Del(state, Data);
    },
  },
  actions: {
    async GetConf({
      state,
      commit
    }) {
      const Conf = await Services.Nozich.GetConfigs();

      if (Conf[Config.App.Type] > Config.App.Version) window.location.reload();

      commit('SetConf', Conf);

      return state.Conf;
    },
    async SetLog({
      commit
    }, {
      Key,
      Value
    }) {
      commit('SetLog', {
        Key,
        Value
      })
    },
    async ClearLogs({
      commit
    }) {
      commit('ClearLogs')
    },
    async Connect({
      state,
      commit,
      dispatch
    }) {
      if (state.ConnectionStatus === CONN.CONNECTING)
        return;

      commit('SetConnectionStatus', CONN.CONNECTING);

      const Connection = await Services.Nozich.Connection();

      Connection.onopen = function () {
        dispatch('ClearToastMessages');
        commit('SetConnection', Connection);
        dispatch('Connected');
      };

      Connection.onmessage = function (Incoming) {
        let OP;

        if (!(OP = JSON.parse(Incoming.data)))
          return;

        if (OP.ID !== undefined && OP.ID !== 0 && Services.Nozich.IsNumeric(OP.ID)) {
          Services.Nozich.RequestIDs[OP.ID](OP.Data);
          delete Services.Nozich.RequestIDs[OP.ID];
          return;
        }

        switch (OP.OpCode) {
          case 'Console':
            window.console.log(OP.Message);
            break;

          case 'Update':
            commit('SetChannelData', {
              Channel: OP.Channel,
              Data: OP.Data
            });
            break;

          case 'Up':
            commit('Up', OP.Data);
            break;

          case 'Del':
            commit('Del', OP.Data);
            break;

          case 'FinishMoveOrders':
            dispatch('FinishMoveOrders', OP.Data);
            break;
        }
      };

      Connection.onclose = function () {
        if (state.ConnectionStatus !== 1)
          return;

        dispatch('ClearToastMessages');
        dispatch('AddToastMessage', {
          Title: "Hata",
          Body: 'Bağlantı koptu.'
        });

        dispatch('DisConnected');
      };

      Connection.onerror = function () {
        dispatch('ClearToastMessages');

        dispatch('AddToastMessage', {
          Title: "Hata",
          Body: 'Bağlantı sırasında hata oluştu.'
        });

        dispatch('DisConnected');
      };
    },
    Connected({
      commit
    }) {
      commit('SetConnectionStatus', CONN.CONNECTED);
    },
    DisConnected({
      state,
      commit,
      dispatch
    }) {
      commit('SetConnectionStatus', CONN.DISCONNECTED);
      dispatch('Logout');

      if (state.ConnectionStatus !== CONN.CONNECTING) {
        Services.Nozich.Delay(() => dispatch('Connect'), 1000);
      }
    },
    Logout({
      commit
    }) {
      commit('SetUser', null);
      commit('SetAccessToken', null);
      commit('SetStoreData', null);
      Services.Nozich.Logout();
    },
    Subscribe({
      commit
    }, Data) {
      commit('SetChannelData', {
        Channel: Data.Channel,
        Data: ''
      });

      Services.Nozich.Subscribe(Data.Type, Data.Channel);
    },
    SetFocusedData({
      commit
    }, Data) {
      commit('SetFocusedData', Data)
    },
    SetData({
      commit
    }, Data) {
      commit('SetData', Data)
    },
    SendForm({
      state,
      commit,
      dispatch
    }, Type) {
      if (this.getters.IsLoading) return false;

      switch (Type) {
        case 'Login':
          commit('AddLoading', 'Login');

          Services.Nozich.Login(state.LoginUsername, state.LoginPassword, (Res) => {
            commit('RemoveLoading', 'Login');

            if (Res.Status === 'Success') {
              commit('SetUser', Res.User);
              localStorage.setItem('AutomaticLogin', Res.User.PasswordLength);
              localStorage.setItem('AppName', Res.User.StoreName);
              commit('SetAccessToken', Res.AccessToken);
              dispatch('SetStoreData', Res.StoreData);

              Services.Nozich.Console(`Login approved for User-${Res.User.ID}`);

              commit('SetData', {
                Key: 'LoginPassword',
                Value: ''
              });
            } else {
              if (state.AutomaticLogin)
                commit('SetData', {
                  Key: 'AutomaticLogin',
                  Value: 9999
                });
              else
                commit('SetData', {
                  Key: 'LoginPassword',
                  Value: ''
                });
            }
          });

          break;

        default:
          break;
      }
    },
    StartSession({
      commit
    }, Params) {
      commit('AddLoading', 'StartSession');

      Services.Nozich.Send('StartSession', {
        Table: Params.Table,
      }, (Res) => {
        commit('RemoveLoading', 'StartSession');

        Params.Callback(Res);

        if (Res.Status === 'Success') {
          Services.Nozich.Console(`StartSession approved ${JSON.stringify(Res)}`)
        }
      });
    },
    LockSession({
      commit
    }, Params) {
      commit('AddLoading', 'LockSession');

      Services.Nozich.Send('LockSession', {
        Table: Params.Table,
      }, (Res) => {
        commit('RemoveLoading', 'LockSession');

        Params.Callback(Res);

        if (Res.Status === 'Success') {
          Services.Nozich.Console(`LockSession approved ${JSON.stringify(Res)}`)
        }
      });
    },
    Order({
      commit
    }, Params) {
      commit('AddLoading', 'Order');

      Services.Nozich.Send('Order', {
        Table: Params.Table,
        Orders: Params.Orders
      }, (Res) => {
        commit('RemoveLoading', 'Order');

        Params.Callback(Res);

        if (Res.Status === 'Success') {
          Services.Nozich.Console(`Order approved ${JSON.stringify(Res)}`)
        }
      });
    },
    Execute({
      commit
    }, {
      OpCode,
      Data,
      Callback
    }) {
      commit('AddLoading', OpCode);

      Services.Nozich.Send(OpCode, Data, (Res) => {
        commit('RemoveLoading', OpCode);

        Callback(Res);

        if (Res.Status === 'Success') {
          Services.Nozich.Console(`${OpCode} approved ${JSON.stringify(Res)}`)
        }
      });
    },
    FetchTables({
      commit
    }) {
      commit('AddLoading', 'FetchTables');

      Services.Nozich.Send('Tables', {}, (Res) => {
        commit('RemoveLoading', 'FetchTables');

        if (Res.Status === 'Success') {
          commit('SetData', {
            Key: 'Tables',
            Value: Res.Tables
          });
        }
      });
    },
    FetchTable({
      commit
    }, ID) {
      commit('AddLoading', 'FetchTable');

      Services.Nozich.Send('Table', {
        ID
      }, (Data) => {
        commit('RemoveLoading', 'FetchTable');

        if (Data.Status === 'Success') {
          commit('SetData', {
            Key: 'Table',
            Value: Data.Table
          });
        }
      });
    },
    FetchProducts({
      commit
    }) {
      commit('AddLoading', 'FetchProducts');

      Services.Nozich.Send('Products', {}, (Res) => {
        commit('RemoveLoading', 'FetchProducts');

        if (Res.Status === 'Success') {
          commit('SetData', {
            Key: 'Products',
            Value: Res.Products
          });
        }
      });
    },
    async FinishMoveOrders({
      state,
      commit
    }, Data) {
      if (!Data.OldTableID || !state.StoreData.Tables[Data.OldTableID]) return false;
      if (!Data.TableID || !state.StoreData.Tables[Data.TableID]) return false;
      if (!Data.Orders || typeof Data.Orders !== 'object' || !Data.Orders.length === 0) return false;

      for (let i in Data.Orders) {
        let _OrderID = Data.Orders[i];
        let _Order = state.StoreData.Tables[Data.OldTableID].Session.Orders[_OrderID];

        if (!state.StoreData.Tables[Data.TableID].Session.Orders) state.StoreData.Tables[Data.TableID].Session.Orders = {};

        await commit('Up', {
          El: ['StoreData', 'Tables', Data.TableID, 'Session', 'Orders', _OrderID],
          Value: _Order
        });

        await commit('Del', {
          El: ['StoreData', 'Tables', Data.OldTableID, 'Session', 'Orders', _OrderID]
        });
      }

      if (Data.Closed !== null) {
        await commit('Del', {
          El: ['StoreData', 'Tables', Data.OldTableID, 'Session']
        });

        await Router.push('/Tables');
      }
    },
    AddLoading({
      commit
    }, Name) {
      commit('AddLoading', Name)
    },
    SetStoreData({
      commit
    }, StoreData) {
      commit('SetStoreData', StoreData)
    },
    SetAccessToken({
      commit
    }, Token) {
      commit('SetAccessToken', Token)
    },
    SetPasswordLength({
      commit
    }, PasswordLength) {
      commit('SetPasswordLength', PasswordLength)
    },
    SetAutomaticLogin({
      commit
    }, AutomaticLogin) {
      commit('SetAutomaticLogin', AutomaticLogin)
    },
    RemoveLoading({
      commit
    }, Name) {
      commit('RemoveLoading', Name)
    },
    GiveError({
      commit
    }, ERR) {
      commit('GiveError', ERR)
    },
    ShowWarning({
      commit
    }, Notice) {
      commit('ShowWarning', Notice)
    },
    RemoveAlerts({
      commit
    }) {
      commit('RemoveAlerts')
    },
    RemoveSoftAlerts({
      commit
    }) {
      commit('RemoveSoftAlerts')
    },
    AddToastMessage({
      commit
    }, Data) {
      commit('AddToastMessage', Data)
    },
    ClearToastMessages({
      commit
    }) {
      commit('ClearToastMessages')
    },
    DeleteToastMessage({
      commit
    }, ID) {
      commit('DeleteToastMessage', ID)
    },
  }
});